// extracted by mini-css-extract-plugin
export default {"closeButton":"PopUpLogin_closeButton__a1yak","rounded":"PopUpLogin_rounded__OQ5xF"};